module.exports = __webpack_public_path__ + "img/Vector.c73586e2.svg";